import { billing } from "store/requests";
import { SET_PAYER_DASHBOARD } from "./actionTypes";

export const addPracticePayer = async (payload) => {
  try {
    let { data } = await billing({
      url: "/addPracticePayer",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

// export const editPractice = async (payload) => {
//   try {
//     let { data } = await billing({
//       url: "/editPractice",
//       payload,
//     });
//     return data;
//   } catch (error) {
//     console.error(error);
//   }
// };

// export const addPracticeLocation = async (payload) => {
//   try {
//     let { data } = await billing({
//       url: "/addPracticeLocation",
//       payload,
//     });
//     return data;
//   } catch (error) {
//     console.error(error);
//   }
// };

export const enrollProvider = async (payload) => {
  try {
    let { data } = await billing({
      url: "/enrollProvider",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getPayerMaster = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPayerMaster",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getProviderDetailsData = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getProviderDetails",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteManualERA = async (payload) => {
  try {
    let { data } = await billing({
      url: "/deleteManualERA",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getPracticePayers = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getPracticePayers",
        payload,
      });
      dispatch({ type: SET_PAYER_DASHBOARD, payload: data });
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const deletePracticePayer = async (payload) => {
  try {
    let { data } = await billing({
      url: "/deletePracticePayer",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updatePracticePayer = async (payload) => {
  try {
    let { data } = await billing({
      url: "/updatePracticePayer",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const addPracticePayerNote = async (payload) => {
  try {
    let { data } = await billing({
      url: "/addPracticePayerNote",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getPracticePayersNotes = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPracticePayersNotes",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getPracticePayersSummary = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPracticePayersSummary",
      payload,
    });
    return data[0];
  } catch (error) {
    console.error(error);
  }
};

export const getElectronicPayerClaims = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getElectronicPayerClaims",
      payload,
    });
    return data[0];
  } catch (error) {
    console.error(error);
  }
};

export const getPaperPayerClaims = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPaperPayerClaims",
      payload,
    });
    return data[0];
  } catch (error) {
    console.error(error);
  }
};
